import React, {cloneElement, useContext, useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import { TableColumn, TableSettings} from "../../../tableSettings";
import AbstractListView, {
  DataFetchResult,ExportRowRenderer,ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../common/AbstractListView";
import * as XCol from '../../../framework.core/XExportColumn';
import constants from '../../../constants';
import {Search} from "../../../filtering";
import {NavigationType, openNewPage} from '../../../util/navigationHelpers';
import {
  CurrencyAmountRenderer,DateRenderer,DateTimeRenderer,NullableCheckboxIconRenderer,
  TextAlignLeftRenderer,TextAlignRightRenderer,TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import UniqueLinkButton from '../../../uiControls/UniqueLinkButton';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import { DocumentType } from "../../../framework.core/DocumentType";
import ApplicationContext from '../../../ApplicationContext';
import JobListViewContext, { RightClickContext } from '../../common/JobListViewContext';
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import ActionButton, {ActionButtonItem, borderColors, splitMenuItemsIntoSections} from '../../../ui/ActionButton';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import {JobNames, getJobNameFromInvBillCrDbJobType} from "../../../framework.core/JobNames";
import {storageInvoiceList} from "../tableSettings";
import {InvoiceListItem} from "../../../fms.data/models/InvoiceListItem";
import IfmsModal from "../../../ui/IfmsModal";
import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';
import JobListSuntekCommand from '../../common/JobListSuntekCommand';
import { StatusNotUseFileLockedRenderer, VoidFilterRenderer } from '../../common/commonListRenderers';
import periodCloseIcon from '../../../img/PeriodClose.svg';
import periodCloseIcon2 from '../../../img/periodclose-12.svg';
import opCloseIcon from '../../../img/OPClose.svg';
import opCloseIcon2 from '../../../img/opclose-12.svg';
import Menu, { IfmsMenuItem } from '../../../ui/menu/Menu';
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import { FmsSubMenu } from '../../../constants/fmsSubMenu';
import { getSelectedSubMenuArgs } from '../../JobListSubMenu';
import useReportViewer from '../../../hooks/useReportViewer';
import BicInfoAreaHistory from '../../common/BicInfoAreaHistory';
import useSystemSettings from '../../../hooks/useSystemSettings';
import CustomerBalanceDetails from '../../reports/AccountBalance';
import { nowDate } from '../../../dateUtils';
import { SuntekSettings, SystemSettings } from '../../../ifmsTypes';
import { useJournal } from '../../accounting/general/journal/JournalListView';
import { FormType, SecType } from '../../../fms.enum';
import { FmsSecTask } from '../../../fms.core/constants';
import { findSecurityTaskWithBranch, getSecBySecTask } from '../../../util';
import { getFmsGlobal } from '../../../globals';
import HistoryView from '../../reports/HistoryView';
import CheckBoxUncontrolled from '../../../ui/CheckBoxUncontrolled';
import { FmsSecCntr } from '../../../fms.core/constants/FmsSecCntr';
import { CurrencyAmountValue, nullableCheckBoxValue } from '../../common/commonExportFormat';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import IconButton, { BalanceIconButton, DeleteIconButton, DeleteIconButton2, EditIconButton, EditIconButton2, JournalIconButton, PrintIconButton, ViewIconButton, ViewIconButton2 } from '../../../ui/IconButton';
import PayIcon2 from '../../../img/Invoice(WH) Pay2.svg';
import PayIcon2_D from '../../../img/Invoice(WH) Pay_Dark2.svg';
import BPrintICon2 from '../../../img/BatchPrint2.svg';
import BPrintICon2_D from '../../../img/BatchPrint_Dark2.svg';
import ViewHsitoryIcon2 from '../../../img/ViewHistory2.svg';
import ViewHsitoryIcon2_D from '../../../img/ViewHistory_Dark2.svg';

function IndicatorRenderer({ data, row }: any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';
  else if (lStatus === 'OC') dataTooltip = 'OP Close';

  let content: React.ReactNode = <></>;
  if (lStatus === 'PC')
    content = <img height="12px" src={periodCloseIcon2} id={'redIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt="" />;
  else if (lStatus === 'OC')
    content = <img height="12px" src={opCloseIcon2} id={'blueIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt="" />;
  //}

  return (
    //<div className="ifms-table-default" style={{width: '100%', minHeight: '22px', cursor: 'pointer'}}>{content}</div>
    <div className="ifms-table-default" data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}


function VoidRenderer({cell}:any) {
  if (cell && cell.value === 1) {
    return (
      <div data-tooltip={'Void'} className="ifms-table-default">
        <span style={{color: 'red'}}>V</span>
      </div>
    );
  }
  return <div className="ifms-table-default"></div>;
}

function ConfirmedRenderer({ value, row }: any) {
  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();


  let secCont = appContext.securityControls ? appContext.securityControls[JobNames.WHStorageInv] : null;
  if (!secCont) {
    secCont = [
    { secCntr: FmsSecCntr.STInvConfirmed, contName: 'chkConfirmed' }

  ];

    appContext.setSecurityControls(JobNames.WHStorageInv, secCont);
  }
  

  async function updateConfirmed(newValue: boolean) {
    await appContext.api.setInvoiceConfirmed(row.original.id, newValue);
    row.original.confirmed = newValue;
    jobListContext.updateDataRow(row.original);
  }

  function findClickedCell(element: Element): Element | null {
    for (let i = 0; i < 6; ++i) {
      if (!element) {
        break;
      }
      if (Array.from(element.classList).some(className => className.startsWith('row-'))) {
        return element;
      }
      element = element.parentNode as Element;
    }
    return null;
  }

  return (
    <div style={{ width: '100%', textAlign: 'center' }}>
      <CheckBoxUncontrolled
        key={row.original.id}
        initialValue={Boolean(value)}
        onChange={updateConfirmed}
        disabled={appContext.getControlDisableStatus(JobNames.WHStorageInv, 'chkConfirmed', FormType.ModeEdit)}
        allowOnChange={async (e) => {
          if (!e) return false;

          e?.stopPropagation();

          const element = findClickedCell(e.currentTarget);
          if (!element) {
            await showGlobalOkDialog(<p>Cannot find hover element</p>, false, null, 'warning');
            return false;
          }

          const classes = element.classList;
          const mouseOverRowIndex = Array.from(classes).find(className => className.includes('row-'))?.match(/\d+$/)?.[0];

          if (!mouseOverRowIndex || !jobListContext.data) {
            await showGlobalOkDialog(<p>Cannot find hover data</p>, false, null, 'warning');
            return false;
          }

          const rowData = jobListContext.data[parseInt(mouseOverRowIndex)];
          if (rowData.void > 0) {
            await showGlobalOkDialog(<p>This Invoice has been voided.</p>);
            return false;
          } else if (rowData.paidAmount !== 0) {
            await showGlobalOkDialog(<p>This Invoice has been already paid.</p>);
            return false;
          } else if (rowData.draft) {
            await showGlobalOkDialog(<p>This Invoice is Draft.</p>);
            return false;
          } else {
            return true;
          }
        }} />
    </div>
  );
}


function useSelectedOperations() {
  const jobListContext = useContext(JobListViewContext);
  const history = useHistory();
  const appContext = useContext(ApplicationContext);
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const fmsGlobal = getFmsGlobal();

  const selectedElement = jobListContext.selectedElement as InvoiceListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();

  async function create() {
    if (jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl('/warehousing/storageInvoice/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress</p>);
      return;
    }

    openNewPage(history, '/warehousing/storageInvoice/add', NavigationType.newPage);
  }

  async function edit() {
    if (!selectedElement) {
      return;
    }
    const id = selectedElement.id;
    const editUrl = `/warehousing/storageInvoice/edit/${id}`;
    const viewUrl = `/warehousing/storageInvoice/view/${id}`;

    // if (jobListContext.hasOpenedScreenInAnyOperationStartingWithUrlWithoutMe(`/warehousing/storageInvoice/edit`, editUrl)) {
    //   await showGlobalOkDialog(<p>Edit operation is already in progress</p>);
    //   return;
    // }
    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  async function view() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/warehousing/storageInvoice/edit/${id}`;
    const viewUrl = `/warehousing/storageInvoice/view/${id}`;
    
    const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.WHStorageInv, selectedElement.branch);
    const urls = [viewUrl];
    if (listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function deleteItem() {
    if (!selectedElement) {
      await showGlobalOkDialog('Cannot delete!',false,null,'warning');
      return;
    }

    if (
      jobListContext.hasOpenedScreenStartingWithUrl(`/warehousing/storageInvoice/edit/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenStartingWithUrl(`/warehousing/storageInvoice/view/${selectedElement.id}`)
    ) {
      await showGlobalOkDialog('Need to close Invoice first', false, null, "warning");
      return;
    }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        <h3>Do you want to Delete?</h3>
      </div>
    ,false, 0, true, 'warning');

    if (doDelete) {
      const apiResult = await appContext.api.deleteJobDetail(JobNames.Invoice, { id: selectedElement.id, opAcctBlockAfterClosed: fmsGlobal?.OPAcctBlockAfterClosed??false });
      if (apiResult && apiResult.success) {
        jobListContext.reloadData();
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message, false,null,'warning');
      }
    }
  }
  return {create, edit, view, deleteItem};
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { create, edit, view, deleteItem } = useSelectedOperations();
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as InvoiceListItem;
  const appContext = useContext(ApplicationContext);
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.WHStorageInv, selectedElement?.branch);

  const items = [
    { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit },
    { label: 'Edit', shortcut: 'F3', separator: true, hidden: !listSec?.grantEdit },
    { label: 'Delete', shortcut: '', separator: true, hidden: !listSec?.grantDel },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
    // { label: 'Refresh', shortcut: 'F11', separator: true },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem name="storageInvoice-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    hidden: i?.hidden ?? false,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        create();
        break;
      case 1:
        view();
        break;
      case 2:
        edit();
        break;
      case 3:
        deleteItem();
        break;
      case 4:
        jobListContext.triggerTableSearch('F5');
        break;
      case 5:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      // case 6:
      //   jobListContext.reloadData();
      //   break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function TrancationImpactButtonCommands({ userId } : {userId: string}) {
  // const jobListContext = useContext(JobListViewContext);
  // const selectedElement = jobListContext.selectedElement as InvoiceListItem;
  // const {switchJournal} = useJournal();
  // const appContext = useContext(ApplicationContext);
  
  // if (!getSecBySecTask(appContext, FmsSecTask.ListJournalBillings, SecType.Read) && !userId.startsWith('@')) {
  //   return null;
  // }

  // return (
  //   <JournalIconButton onClick={()=> switchJournal(JobNames.WHStorageInv, selectedElement.id)} useText/>
  // );
  return null;
}

function ListCommands() {
  const history = useHistory();
  const jobListContext = useContext(JobListViewContext);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem|null>(null);
  const appContext = useContext(ApplicationContext);
  
  const hasSecCp = getSecBySecTask(appContext, FmsSecTask.AcctCustPayment, SecType.Add);
  const hasSecBp = getSecBySecTask(appContext, FmsSecTask.AcctBillPayment, SecType.Add);

  const selectedElement = jobListContext.selectedElement as InvoiceListItem;
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const { viewReport } = useReportViewer();
  const {switchJournal} = useJournal();

  const {edit, view, deleteItem } = useSelectedOperations();

  function hasOpenedNew() {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/warehousing/storageInvoice/add`);
  }

  async function viewPaymentHistory() {
    if (!selectedElement) {
      return;
    }

    const jobId = selectedElement.id;
    const jobName = JobNames.Invoice;
    const jobType = selectedElement.jobType

    const viewUrl = `/accounting/acPaymentHistoryView/${jobName}/${jobId}/${getJobNameFromInvBillCrDbJobType(jobType)}`;
    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function print() {
    if (!selectedElement) {
      return;
    }

    let puInvoice: boolean = false;

    if (appContext.suntekSettings?.company?.companyId === "AECL002209") {
      const doConfirm = await showGlobalYesNoDialog(
        <div>
          <h3>Do you want to Print?</h3>
          <p>Do you want to print P/U Invoice?</p>
        </div>
      ,false, 0, true);
      if (doConfirm) {
        puInvoice = true;
      }
    }

    if (!puInvoice && appContext.suntekSettings?.company?.country === "MEXICO" && appContext.suntekSettings?.company?.companyId === "PEOP002103") {
      // Batch Invoice
      openNewPage(history, '/accounting/batchPrint/invoice/add', NavigationType.newPage);
    } else {
      const args = await getSelectedSubMenuArgs(puInvoice ? FmsSubMenu.PuInvoice : FmsSubMenu.Invoice, JobNames.Invoice, selectedElement, appContext, null, null);
      if (args) {
        viewReport(args, "", true);
      }
    }
  }

  async function onCustomerBillAction(item: ActionButtonItem) {
    //const link = item.index === 0 ? '/accounting/acCustomerPayment/add' : '/accounting/acBillPayment/add';
    let link = '';

    switch (item.index) {
      case 0:
        link = '/accounting/acCustomerPayment/add';
        break;
      case 1:
        link = '/accounting/acBillPayment/add';
        break;
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl(link)) {
      await showGlobalOkDialog(<p>Payment New Operation is already in progress</p>);
      return;
    }

    openNewPage(history, `${link}/${selectedElement.invoiceTo}`, NavigationType.newPage);
  }

  function onHistoryBtnAction(item: ActionButtonItem) {
    switch (item.index) {
      case 0:
        viewPaymentHistory();
        break;
      case 1:
        setSelectedPopupMenuItem({ label: 'View History', popupWidth: 1225, popupComponent: <HistoryView jobId={selectedElement.id} jobType={selectedElement.jobType} jobName={JobNames.WHStorageInv} /> });
        break;
    }
  }
  
  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }

  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.WHStorageInv, selectedElement?.branch);
  const hasSelectedRow = !!selectedElement;
  const disablePrint = hasSelectedRow && selectedElement.draft;

  const canBeAdd = !hasOpenedNew() && listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;
  const canBeDel = hasSelectedRow && listSec?.grantDel;
  const hasSecBal = getSecBySecTask(appContext, FmsSecTask.ListBalance, SecType.Read);
  const userId = appContext.user?.id ?? '';
  const checkSecJournal = !getSecBySecTask(appContext, FmsSecTask.ListJournalBillings, SecType.Read) && !userId.startsWith('@')

  return (
      <div className='ifms-common-no-vertical-separator-gap-margin'>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ?  <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}/> : <></>} */}
      <div className='ifms-common-vertical-gap-8'>
        <UniqueLinkButton newStyle name='storageInvoice-list-add-button' display="primary" link="/warehousing/storageInvoice/add" disabled={!canBeAdd} label={''} useOnlyIcon data-tooltip='New' iconMode />
        <EditIconButton2 name='storageInvoice-list-edit-button' disabled={!canBeEdit} onClick={edit} useText/>
        <ViewIconButton2 name='storageInvoice-list-view-button' disabled={!hasSelectedRow} onClick={view} useText iconHeight='26px' />
        <DeleteIconButton2 name='storageInvoice-list-del-button' disabled={!canBeDel} onClick={deleteItem} useText/>
      </div>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ?  <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}/> : <></>}
      <PrintIconButton name='storageInvoice-list-print-button' disabled={disablePrint} onClick={print} useText/>
      <IconButton data-tooltip='Batch Print' useOnlyIcon  useText
        disabled={disablePrint} icon={appContext.useDarkMode ? BPrintICon2_D : BPrintICon2}
        onClick={() => setSelectedPopupMenuItem({ label: 'Invoice Batch Print', popupComponent: <BatchPrint selectedElement={selectedElement} documentType={DocumentType.InvoiceS} jobName={JobNames.RptInvoiceS} /> })}
      >
      </IconButton>
      {(hasSecCp || hasSecBp) &&
        <>
          {appContext.suntekSettings?.company?.billingsTabVersion === 2 ?  <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}/> : <></>}
          <ActionButton
          size='extrasmall'
            type= {appContext.suntekSettings?.company?.billingsTabVersion === 2 ? 'primary' : 'iconButton'}
            tooltip='Pay'
            useInList = {appContext.suntekSettings?.company?.billingsTabVersion !== 2}
            items={[
              { label: 'New Customer Pay', separator: false, index: 0, hidden: !hasSecCp },
              { label: 'New Bill Pay', separator: false, index: 1, hidden: !hasSecBp },
            ]}
            onItemSelected={onCustomerBillAction}
          >
            <img src={appContext.useDarkMode ? PayIcon2_D : PayIcon2} alt="" />
          </ActionButton>
        </>
      }
      <>
        {appContext.suntekSettings?.company?.billingsTabVersion === 2 ? <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"} /> : <></>}
        <ActionButton
          name='sinvoice-list-viewhistory-button'
          size='extrasmall'
          type={appContext.suntekSettings?.company?.billingsTabVersion === 2 ? 'primary' : 'iconButton'}
          tooltip='View History'
          useInList={appContext.suntekSettings?.company?.billingsTabVersion !== 2}
          items={[
            { label: 'Payment History', separator: false, index: 0, hidden: !hasSelectedRow, name: "sinvoice-list-payment-button" },
            { label: 'View History', separator: false, index: 1, hidden: !hasSelectedRow, name: "sinvoice-list-history-button" },
          ]}
          onItemSelected={onHistoryBtnAction}
        >
          <img src={appContext.useDarkMode ? ViewHsitoryIcon2_D : ViewHsitoryIcon2} alt="" />
        </ActionButton>
        &nbsp;
      </> */}
      {/* <PrimaryButton onClick={viewPaymentHistory}>Payment History</PrimaryButton>
        <PrimaryButton disabled={!hasSelectedRow} onClick={() => setSelectedPopupMenuItem({ label: 'View History', popupWidth: 1200, popupComponent: <HistoryViewDetails jobId={selectedElement.id} jobType={selectedElement.jobType} jobName={JobNames.WHStorageInv} /> })}>View History</PrimaryButton> */}
      {hasSecBal && (
        <BalanceIconButton
          disabled={!hasSelectedRow}
          onClick={() => setSelectedPopupMenuItem({
            label: 'Balance',
            popupWidth: 780,
            popupComponent:
              <CustomerBalanceDetails
                jobId={selectedElement.id}
                jobName={JobNames.WHStorageInv}
                onPopupClose={onPopupClose}
                //toDate={invoice.postDate || ''}
                toDate={nowDate()}
                comId={selectedElement.invoiceTo}
                comType={'C'}
                branch={''}
                subCode={''}
                customerName={selectedElement.invoiceToName}
              />
          })}
          useText
        />
      )}
      {!checkSecJournal && <JournalIconButton onClick={()=> switchJournal(JobNames.WHStorageInv, selectedElement.id)} useText/> }
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, { onPopupClose })}
        </IfmsModal>
      ) : null}
    </div>
  );
}

function ListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function ListViewExtras({
  hideLogHistory
}: any,
) {
  useFunctionKeys({onFunction: onFunctionKey});

  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as InvoiceListItem;
  //const history = useHistory();
  const systemSettings = useSystemSettings();
  const {create, edit, view} = useSelectedOperations();
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.WHStorageInv, selectedElement?.branch);

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === 'F6') {

    } else if (unprocessedFkey === "F2") {
      if(listSec?.grantAdd)
        create();
    } else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === "F9") {
      view();
    // } else if (unprocessedFkey === "F11") {
    //   jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F6', 'F2', 'F3', 'F9', 'F11', 'F8'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  
  async function loadInvoiceHistory(param: any) {
    //const apiResult = await appContext.api.getOceanImportInvoiceHistory(id);
    const apiResult = await appContext.api.getAcctHistory(param.jobName, param.jobId, (jobListContext.selectedElement as InvoiceListItem).jobType, false);
    if (!apiResult || !apiResult.success) {
      return null;
    }

    return <BicInfoAreaHistory context="invoice" historyData={apiResult.result} primaryCurrency={systemSettings?.primaryCurrency ?? ''} />
  }


  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      jobName={JobNames.Invoice}
      jobId={(jobListContext.selectedElement as InvoiceListItem | null)?.id ?? 0}
      onClose={() => jobListContext.setInfoAreaContent('none')}
      hideLogHistory={hideLogHistory}
    />
  );
}

/**
 * Concrete implementation for Other Shipment List screen
 *
 * @class ListView
 * @extends {AbstractListView}
 */
class ListView extends AbstractListView {

  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.WHStorageInv,
      'InvoiceListItem',
      InvoiceListItem.calculateSearchParameters(search, InvoiceListItem.MapSearchFields, ['void']),
      pageNum,
      limit,
      search.pageSize,
      search.pagePerBatch,
      );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return {data: InvoiceListItem.formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number): Promise<Array<any>> {
    const apiResult = await api.getListItems(JobNames.WHStorageInv, 'InvoiceListItem',
      InvoiceListItem.calculateSearchParameters(search, InvoiceListItem.MapSearchFields, ['void']),
      pageNum,
      limit,
      pageSize,
      pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return InvoiceListItem.formatData(apiResult.entities);
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      {
        accessor: 'statusNotUseFileLocked',
        renderer: StatusNotUseFileLockedRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'void',
        renderer: VoidFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v === 'V' ? 1 : 0,
      },
      {
        accessor: 'confirmed',
        renderer: undefined,
        searchValueExtractor: (v: any | null | undefined) => v.value !== undefined ? v.value : v,
      },
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): ListRowRenderer[] {
    const useBranch = systemSettings?.enableBranch ?? false;
    const useVat = systemSettings.useVat ?? false;

    return InvoiceListItem.getExportCollection(JobNames.WHStorageInv, useBranch, useVat).map(x => {
      const colRenderer: ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if (x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if (x.align === XCol.XAlignType.Right) colRenderer.Cell = TextAlignRightRenderer;
      if (x.dataIndex === "status") {
        colRenderer.Cell = IndicatorRenderer;
      }
      else if (x.dataIndex === "void") {
        colRenderer.Cell = VoidRenderer;
      }
      else if (x.dataIndex === "confirmed") {
        colRenderer.Cell = ConfirmedRenderer;
      } 
      else if (x.dataIndex === "amount" || x.dataIndex === "paidAmount" || x.dataIndex === "balance" || x.dataIndex === "vatAmount") {
        colRenderer.Cell = props => <CurrencyAmountRenderer currencyAccessor={(x: any) => x.currency} {...props} />;
      }
      else if (x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if (x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if (x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      return colRenderer;
    });
  }

  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({ accessor: 'status', changedValue: (value: any) => { return value['status'] === 'PC' ? 'Period Close' : '' } });
    colRenderer.push({ accessor: 'amount', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['amount']) } });
    colRenderer.push({ accessor: 'paidAmount', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['paidAmount']) } });
    colRenderer.push({ accessor: 'balance', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['balance']) } });
    colRenderer.push({ accessor: 'vatAmount', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['vatAmount']) } });
    colRenderer.push({ accessor: 'void', changedValue: (value: any) => { return value['void'] === 1 ? 'checked' : ''} });
    colRenderer.push({ accessor: 'confirmed', changedValue: (value: any) => { return nullableCheckBoxValue(value['confirmed']) } });
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'invoiceDate',
      orderByAscending: false,
    };
  }

  getTableSettings(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): TableSettings {
    const useBranch = systemSettings?.enableBranch ?? false;
    const useVat = systemSettings.useVat ?? false;
    const tsettings =  storageInvoiceList;
    const cols = InvoiceListItem.getExportCollection(JobNames.WHStorageInv, useBranch, useVat);
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <ListCommands/>
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar/>
    );
  }

  renderExtras(hideLogHistory: boolean) {
    return <ListViewExtras hideLogHistory={hideLogHistory} />
  }

  getViewUrlFor(row: InvoiceListItem) {
    return row && row.id ? `/warehousing/storageInvoice/view/${row.id}` : '';
  }

  getListViewTitle() {
    return 'Storage Invoice List';
  };
  
  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.WHStorageInv} keyProp='id' showAdjustBalance={false} />;
  }
  
  useLogHistory(): boolean {
    return true;
  }
  
  transactionImpactBtn(userId: string): React.ReactNode {
    return <TrancationImpactButtonCommands userId={userId} />
  }
}

export default ListView;
